<div class="card border rounded border-secondary mb-2 shadow-md">
  <div class="card-header" id="flatheadingOne">
    <a
      class="collapse-title"
      data-toggle="collapse"
      [attr.data-target]="'#flat' + result.transactionSid"
      aria-expanded="true"
      aria-controls="collapseOne"
    >
      <div class="container">
        <div class="row m-2 align-items-center">
          <div class="col">ID: {{ result.transactionSid }}</div>
          <div class="col">{{ formatTransactionDate(result.transactionTs, result.pharmacyTimeZoneCode) }}</div>
          <div class="col">
            <div
              class="transaction-code"
              [ngClass]="getActivityTypeColorClass(result.transactionCode)"
            >
              {{ result.transactionCode }}
            </div>
          </div>
          <div class="d-none d-sm-block col-sm">
            {{ result.pharmacyName }}
          </div>
        </div>
      </div>
    </a>
  </div>
  <div
    [id]="'flat' + result.transactionSid"
    class="collapse"
    aria-labelledby="flatheadingOne"
    data-parent="#accordionFlat"
  >
    <div class="card-body text-muted bg-pumice">
      <section class="container-fluid p-3">
        <h5 class="font-weight-bold text-primary">Transaction Details</h5>
        <div class="row bg-white rounded p-3">
          <div class="col-md-6 mb">
            <span class="font-weight-bold">Transaction ID:</span>
            {{ result.transactionSid }}
          </div>
          <div class="col-md-6 mb-1">
            <span class="font-weight-bold">Store ID:</span>
            {{ result.pharmacyName }}
          </div>
          <div class="col-md-6 mb-1">
            <span class="font-weight-bold">Product (s):</span>
            {{ result.products }}
          </div>
          <div class="col-md-6 mb-1">
            <span class="font-weight-bold">Compliance Fail Type:</span>
            {{ result.failReason }}
          </div>
          <div class="col-md-6 mb-1">
            <span class="font-weight-bold">Total Boxes:</span>
            {{ result.totalBoxes }}
          </div>
          <div class="col-md-6 mb-1">
            <span class="font-weight-bold">Total Grams:</span>
            {{ result.totalGrams }}
          </div>
        </div>
      </section>
      <section
        *ngIf="result.transactionCode === 'BLOCKED'"
        class="container-fluid p-3"
      >
        <h5 class="font-weight-bold text-primary">Compliance Fail Reason</h5>
        <div class="row bg-white rounded p-3">
          <div class="d-flex flex-column">
            <div *ngIf="getFederalLimits(result).length" class="mb-2">
              <span class="font-weight-bold">Federal Purchase Limits</span>
              <div *ngFor="let compliancelimit of getFederalLimits(result)">
                <span>{{ compliancelimit.detailedCheckDesc }}</span>
              </div>
            </div>
            <div class="mb-2">
              <div *ngIf="getStateLimits(result).length">
                <span class="font-weight-bold">
                  {{ getStateLimits(result)[0].nplexAnswersDesc }}
                </span>
              </div>
              <div *ngFor="let compliancelimit of getStateLimits(result)">
                <span>{{ compliancelimit.detailedCheckDesc }}</span>
              </div>
            </div>
            <div class="mb-2">
              <div *ngFor="let compliancelimit of getSiteLimits(result)">
                <div *ngIf="getSiteLimits(result).length">
                  <span class="font-weight-bold">
                    {{ getSiteLimits(result)[0].nplexAnswersDesc }}
                  </span>
                </div>
              </div>
              <div *ngFor="let compliancelimit of getSiteLimits(result)">
                <span>{{ compliancelimit.detailedCheckDesc }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
